import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AuthViewComponent } from '../components/auth-view/auth-view.component';
import { LoginFormComponent } from './components/login-form/login-form.component';

@Component({
  selector: 'app-login',
  imports: [LoginFormComponent, AuthViewComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  private readonly _route = inject(ActivatedRoute);

  private readonly _queryParams = toSignal(this._route.queryParamMap);

  protected readonly logoutReason = computed(() => {
    const reason = this._queryParams()?.get('reason');
    if (reason === 'moved') {
      return 'Je werd uitgelogd omdat je account is verplaatst naar een andere unit.';
    }
    if (reason === 'tree-changed') {
      return 'Je werd uitgelogd omdat de unit-structuur is gewijzigd.';
    }
    return null;
  });
}
